/* eslint-disable operator-linebreak */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import axios from "axios";

import notify from "../utils/notify";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 0) {
        notify({
          heading: "Unknown Error",
          type: "failure",
          messageList: [
            "An unknown error occurred. Please try again later or contact our support team for assistance. We apologize for any inconvenience caused.",
          ],
        });
      }
    }
    return Promise.reject(error);
  },
);

const authorizedApiClient = axios.create({
  baseURL: import.meta.env.VITE_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

authorizedApiClient.interceptors.request.use((config) => {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz) {
      config.headers = config.headers ?? {};
      (config.headers as Record<string, string>)['X-User-Timezone'] = tz;
    }
  } catch {
    // non-fatal — if Intl lookup throws in older browsers, just skip the header
  }
  return config;
});

export { apiClient, authorizedApiClient };
